/**
 * Service: venue
 */
angular.module('acme.common.service.venue', [])
.service('VenueService', [function() {

    return {

      requestTypes: [
        'reseller',
        'groupBuyer'
      ],

      init: function() {
        return true;
      },

      parseHours: function(hours) {
        var s, a0, a1, h0, m0, h1, m1, t0, t1, time;

        if (hours.indexOf('-') !== false) {
          s = hours.split('-');

          t0 = s[0].split(':');
          h0 = parseInt(t0[0], 10);
          m0 = t0[1];

          t1 = s[1].split(':');
          h1 = parseInt(t1[0], 10);
          m1 = t1[1];

          if (h0 >= 0 && h0 < 12) {
            a0 = 'AM';
          }else{
            a0 = 'PM';
            h0 -= 12;
          }

          if (h1 >= 0 && h1 < 12) {
            a1 = 'AM';
          }else{
            a1 = 'PM';
            h1 -= 12;
          }

          if (parseInt(m1, 10) === 0) {
            m1 = '';
          }else{
            m1 = ':' + m1;
          }

          if (parseInt(m0, 10) === 0) {
            m0 = '';
          }else{
            m0 = ':' + m0;
          }

          time = h0 + m0 + ' ' + a0;
          time += ' - ';
          time += h1 + m1 + ' ' + a1;

        }else{
          time = hours;
        }

        return time;

      },

      getStatusLabel: function(type, status) {

        var s,
          t = '',
          r = '';

        if (status) {

          s = status.toLowerCase();

          switch (s) {
            case 'pending':
              r = 'Pending';
              if (type) {
                r += ' ';
              }
              break;
            case 'declined':
              r = 'Declined';
              if (type) {
                r += ' as ';
              }
              break;
            case 'approved':
              r = 'Approved';
              if (type) {
                r += ' as ';
              }
              break;
            default:
              r = 'Apply';
              if (type) {
                r += ' for ';
              }
          }

        }

        if (type) {

          switch (type) {
            case 'reseller':
              t = 'Reseller';
              break;
            case 'groupBuyer':
              t = 'Group Buyer';
              break;
          }
        }

        return r + t;

      },

      checkRequestAll: function() {

        var i, ii,
          r = false,
          applied = 0;

        for (i=0,ii=this.requestTypes.length;i<ii;i++) {
          if (this.hasApplied(this.requestTypes[i])) {
            applied++;
          }
        }

        if (applied === ii) {
          r = true;
        }

        return r;
      },

      hasApplied: function(requests, type) {
        var i, ii,
            r = false;

        if (requests instanceof Array) {
          for (i = 0, ii = requests.length; i < ii; i++) {
            if (requests[i].type === type) {
              r = true;
              break;
            }
          }
        }

        return r;
      },

      hasApproved: function(requests) {

        var i, ii,
            r = false;

        if (requests instanceof Array) {
          for (i = 0, ii = requests.length; i < ii; i++) {
            if (requests[i].status === "approved") {
              r = true;
              break;
            }
          }
        }

        return r;

      },

      processHours: function(venue) {
        var i, ii,
            j, jj;

        if (venue.openHours && venue.openHours.standard) {
          for (i=0,ii=venue.openHours.standard.length;i<ii;i++) {
            venue.openHours.standard[i].day = venue.openHours.standard[i].weekdays[0].substring(0, 3);
            venue.openHours.standard[i].times = [];
            for (j=0,jj=venue.openHours.standard[i].hours.length;j<jj;j++) {
              venue.openHours.standard[i].times.push(this.parseHours(venue.openHours.standard[i].hours[j]));
            }
          }
        }
        return venue;
      },

      process: function(venues) {
        var i, ii;

        for (i=0,ii=venues.length;i<ii;i++) {
          if (venues[i].openHours) {
            venues[i] = this.processHours(venues[i]);
          }
        }

        return venues;

      }

    };

}]);